import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import SitterReviews from './SitterReviews';
import useUser from '../../store/useUser';
import ParentReviews from './ParentReviews';

function ReviewLookup() {
  const userState = useUser()[0];
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          textColor='primary'
          indicatorColor='primary'
          sx={{
            '& .MuiTab-root': {
              fontWeight: 400,
              opacity: 0.7,
            },
            '& .Mui-selected': {
              fontWeight: 600,
              opacity: 1,
              backgroundColor: 'rgba(0, 187, 205, 0.08)',
            },
            '& .MuiTabs-indicator': {
              height: 3,
            },
          }}
        >
          <Tab label={userState.user.parent ? 'Reviews of Sitters' : "Sitter's Reviews"} />
          <Tab label={userState.user.parent ? "Parent's Reviews" : 'Reviews of Parents'} />
        </Tabs>
      </Box>
      {activeTab === 0 ? <SitterReviews /> : <ParentReviews />}
    </>
  );
}

export default ReviewLookup;
